class Reveil {

	constructor() {
		this.observer = null;
		this.items = [];
	}

	add(item, callback) {
		const newItem = item;
		newItem.reveilCallback = callback;
		this.items.push(newItem);

		if (!this.observer) {
			this.startObserver();
		}

		this.observer.observe(newItem);
	}

	remove(item) {
		// const index = this.items.indexOf(item);
		this.items.splice(item, 1);
		this.observer.unobserve(item);
	}

	startObserver() {
		const options = {
			root: null,
			rootMargin: '-10%'
		};
		this.observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					entry.target.reveilCallback();
					this.remove(entry.target);
				}
			});
		}, options);
	}

}

export default new Reveil();